import { PROFILE } from "../data/profile";

function profileText() {
  const skills = Object.entries(PROFILE.skills)
    .map(([k, v]) => `- ${k}: ${v.join(", ")}`)
    .join("\n");
  const certs = PROFILE.certifications
    .map((c) => `- ${c.title} (${c.issuer}, ${c.year})`)
    .join("\n");
  const projects = PROFILE.projects
    .map((p) => `- ${p.name} — ${p.tag}: ${p.desc} Tech: ${p.stack.join(", ")}.`)
    .join("\n");
  return [
    `NAME: ${PROFILE.name}`,
    `TITLE: ${PROFILE.titles.join(" · ")}`,
    `LOCATION: ${PROFILE.location}`,
    `EMAIL: ${PROFILE.email} | PHONE: ${PROFILE.phone}`,
    `EXPERIENCE: ${PROFILE.years_experience} years`,
    "",
    `SUMMARY:\n${PROFILE.summary}`,
    "",
    `SKILLS:\n${skills}`,
    "",
    `CERTIFICATIONS:\n${certs}`,
    "",
    `PROJECTS:\n${projects}`,
  ].join("\n");
}

export function buildSystemPrompt(feature, extra) {
  const base = profileText();
  const common =
    "You are an AI agent representing Shivmurat Gupta, a Software Developer with 4+ years of experience in Python, Django, AWS and AI/ML. Use ONLY the facts below. Be concise, professional, and never invent details not present. Use short paragraphs and bullet points when helpful. If a question is outside this profile, say so honestly.\n\n=== SHIVMURAT'S PROFILE ===\n" +
    base +
    "\n";

  switch (feature) {
    case "persona_chat":
      return (
        common +
        "\nROLE: Friendly first-person assistant. When asked 'who are you?', answer as Shivmurat. Keep replies under ~150 words unless asked for detail."
      );
    case "project_recommender":
      return (
        common +
        "\nROLE: AI project recommender for recruiters.\nTASK: Given the recruiter's description, recommend 2–4 MOST relevant projects from the profile. For each, briefly explain WHY it matches and which skills it demonstrates. End with a one-line summary of Shivmurat's overall fit."
      );
    case "cover_letter":
      return (
        common +
        (extra ? `\nJOB DESCRIPTION / ROLE NOTES:\n${extra}\n` : "") +
        "\nROLE: Writing assistant drafting a tailored cover letter intro for Shivmurat.\nTASK: Write a concise 3-paragraph cover letter (~180 words) that opens warmly, maps Shivmurat's skills/projects to the role's needs, and closes with a clear call to action. Confident and professional tone. Do NOT invent past employers."
      );
    case "resume_qa":
      return (
        common +
        "\nROLE: 'Ask my resume' answering agent.\nTASK: Answer the user's question STRICTLY using the profile above. If the answer isn't in the profile, say so honestly. Cite the project or skill section."
      );
    default:
      return common;
  }
}
